import { createFileRoute } from '@tanstack/react-router';
import TeamsPage from '@/pages/setup/teams/TeamsPage';
import { requireSetupPageAccess } from '@/lib/setup-route-guard';

export interface TeamsSearch {
  id?: string;
}

export const Route = createFileRoute('/_authenticated/setup/teams')({
  beforeLoad: () => requireSetupPageAccess('/setup/teams'),
  validateSearch: (raw: Record<string, unknown>): TeamsSearch => ({
    id: (raw.id as string) ?? undefined,
  }),
  component: TeamsPage,
});
